import c from "react";
import { C as g } from "./CloseOutlined-C-avmD02.mjs";
import { p as C } from "./pickAttrs-bNG7_x1p.mjs";
function O(s) {
  if (s)
    return {
      closable: s.closable,
      closeIcon: s.closeIcon
    };
}
function d(s) {
  const {
    closable: l,
    closeIcon: e
  } = s || {};
  return c.useMemo(() => {
    if (
      // If `closable`, whatever rest be should be true
      !l && (l === !1 || e === !1 || e === null)
    )
      return !1;
    if (l === void 0 && e === void 0)
      return null;
    let n = {
      closeIcon: typeof e != "boolean" && e !== null ? e : void 0
    };
    return l && typeof l == "object" && (n = Object.assign(Object.assign({}, n), l)), n;
  }, [l, e]);
}
function m() {
  const s = {};
  for (var l = arguments.length, e = new Array(l), n = 0; n < l; n++)
    e[n] = arguments[n];
  return e.forEach((t) => {
    t && Object.keys(t).forEach((o) => {
      t[o] !== void 0 && (s[o] = t[o]);
    });
  }), s;
}
const b = {};
function h(s, l) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : b;
  const n = d(s), t = d(l), o = c.useMemo(() => Object.assign({
    closeIcon: /* @__PURE__ */ c.createElement(g, null)
  }, e), [e]), a = c.useMemo(() => n === !1 ? !1 : n ? m(o, t, n) : t === !1 ? !1 : t ? m(o, t) : o.closable ? o : !1, [n, t, o]);
  return c.useMemo(() => {
    if (a === !1)
      return [!1, null];
    const {
      closeIconRender: u
    } = o, {
      closeIcon: i
    } = a;
    let r = i;
    if (r != null) {
      u && (r = u(i));
      const f = C(a, !0);
      Object.keys(f).length && (r = /* @__PURE__ */ c.isValidElement(r) ? /* @__PURE__ */ c.cloneElement(r, f) : /* @__PURE__ */ c.createElement("span", Object.assign({}, f), r));
    }
    return [!0, r];
  }, [a, o]);
}
export {
  O as p,
  h as u
};
//# sourceMappingURL=useClosable-DkzVjsgR.mjs.map
